
define("json!gigaset_recurring/handles/gigaset_recurring.json", function(){ return {
	"gigaset_recurring_checkout_index_index": [
		"cartware_checkout/components/agreements"
	],

	"gigaset_recurring_checkout_index_index__billwerk": [
		"gigaset_recurring/components/checkout/provider/billwerk/main"
	],

	"gigaset_recurring_checkout_provider_billwerk_finalize": [
		"gigaset_recurring/components/checkout/provider/billwerk/finalize"
	],

	"customer_subscriptions_billwerk_view": [
		"gigaset_recurring/components/customer/subscription/provider/billwerk/view"
	],

	"customer_subscriptions_billwerk_finalizepaymentchange": [
		"gigaset_recurring/components/customer/subscription/provider/billwerk/view"
	],

	"PRODUCT_TYPE_gigaset_recurring_plan_config": [
		"gigaset_recurring/components/catalog/product/plan/configurable/options",
		"cartware/components/magento/product/type/configurable",
		"shoptheme/components/product/type/configurable"
	]

};});

